import localSiteSettings from '~/content/site-settings'

export function useSettings() {
    const settings = ref<any>({})

    async function fetchSettings() {

        const route = useRoute()
        const isStoryblokPreview =
            Boolean(route.query?._storyblok) ||
            Boolean(route.query?.['_storyblok_tk[space_id]'])
        const config = useRuntimeConfig()

        if (config.public.localCampaignPreview) {
            settings.value = localSiteSettings
            return
        }

        const cv = config.public.cv
        const version = isStoryblokPreview ? 'draft' : 'published'

        const { data } = await useStoryblokApi().get('cdn/stories/settings', {
            version,
            cv: Number(isStoryblokPreview ? Date.now() : cv),
            resolve_relations: []
        })

        const story = data?.story

        if (!story) {
            throw createError({
                statusCode: 404,
                statusMessage: 'Settings story not found'
            })
        }

        settings.value = story.content

        if (process.client && isStoryblokPreview && story.id) {
            useStoryblokBridge(story.id, (evStory:any) => {
                settings.value = evStory.content
            })
        }

    }


    return {
        settings,
        fetchSettings,
    }
}
